module.exports = __webpack_public_path__ + "media/3.d7869834.mp3";